import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {JsonEventInfo, JsonEventPartyCompInfoStatusEnum, JsonEventPartyInfo, JsonTariffInfo} from "../../generated-api";
import {formatMoney, getOption} from "../../model/form";
import {useAppTranslation} from "../../services/i18n";
import {vehicleOptions} from "../../model/invite";
import {datetimeToGui, dateToGuiAs} from "../../helpers/date";
import {Done, HourglassTopRounded} from "@mui/icons-material";
import {renderPaymentConfirmationFile} from "../../helpers/files";
import * as React from "react";

type PartyCompDetailsProps = {
    eventParty: JsonEventPartyInfo,
    tariffs?: JsonTariffInfo[],
    withAccount?: boolean,
    event?: JsonEventInfo,
}

export const PartyCompDetails = (props: PartyCompDetailsProps) => {
    const {eventParty, tariffs, withAccount, event} = props;

    const t = useAppTranslation();

    const items: JSX.Element[] = [];

    let total = 0;

    if (eventParty.eventCompDetails?.length && eventParty.eventCompDetails.length > 0) {
        items.push(<TableContainer key={0} component={Paper} sx={{order: 50}}>
            <Table className={'data-grid'}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width: '50%'}}><span>{t('Tarif')}</span></TableCell>
                        <TableCell sx={{width: '13%', textAlign: 'right'}}><span>{t('Sazba')}</span></TableCell>
                        <TableCell sx={{width: '14%', textAlign: 'right'}}><span>{t('Jednotek')}</span></TableCell>
                        <TableCell sx={{width: '15%', textAlign: 'right'}}><span>{t('Odměna')}</span></TableCell>
                        <TableCell sx={{width: '8%'}}><span></span></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {eventParty.eventCompDetails.map((epc, i) => {
                        const tariff = tariffs?.find((t) => t.tariffId === epc.tariffId);
                        total += epc.compAmount || 0;
                        return <TableRow key={epc.eventPartyCompId}>
                            <TableCell>
                                <span>{epc.title || tariff?.unitTitle || epc.tariffId}</span>
                            </TableCell>
                            <TableCell sx={{textAlign: 'right'}}>
                                <span>{formatMoney(epc.unitAmount || tariff?.unitRate || 0, true)}</span>
                            </TableCell>
                            <TableCell sx={{textAlign: 'right'}}>
                                <span>{epc.unitCnt || 0}</span>
                            </TableCell>
                            <TableCell sx={{textAlign: 'right'}}>
                                <span>{formatMoney(epc.compAmount || 0, true)}</span>
                            </TableCell>
                            <TableCell sx={{textAlign: 'center'}}>
                                {!!event && epc.status === JsonEventPartyCompInfoStatusEnum.Active &&
                                    <span title={t('K výplatě')}><HourglassTopRounded/></span>}
                                {!!event && epc.status === JsonEventPartyCompInfoStatusEnum.Paid &&
                                    <span title={t('Vyplaceno')}><Done/></span>}
                            </TableCell>
                        </TableRow>;
                    })}
                    <TableRow>
                        <TableCell colSpan={3}><span><strong>{t('Celkem odměny')}</strong></span></TableCell>
                        <TableCell sx={{textAlign: 'right'}}>
					<span><strong>{formatMoney(eventParty.eventCompDetails.reduce(
                        (s, epc) => s + (epc.compAmount || 0), 0) || 0, true)}
					</strong></span>
                        </TableCell>
                        <TableCell>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>);
    }

    if (eventParty.eventTravelDetails?.length && eventParty.eventTravelDetails.length > 0) {
        items.push(<TableContainer key={1} component={Paper} sx={{order: 50}}>
            <Table className={'data-grid'}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width: '7%'}}><span title={t('Dopravní prostředek')}>P</span></TableCell>
                        <TableCell sx={{width: '10%'}}><span>{t('Odjezd')}</span></TableCell>
                        <TableCell sx={{width: '20%'}}><span>{t('Z')}</span></TableCell>
                        <TableCell sx={{width: '10%'}}><span>{t('Příjezd')}</span></TableCell>
                        <TableCell sx={{width: '20%'}}><span>{t('Do')}</span></TableCell>
                        <TableCell sx={{width: '10%'}}><span></span></TableCell>
                        <TableCell sx={{width: '15%', textAlign: 'right'}}><span>{t('Náhrada')}</span></TableCell>
                        <TableCell sx={{width: '8%'}}><span></span></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {eventParty.eventTravelDetails.map((ept, i) => {
                        const o = getOption(ept.vehicle, vehicleOptions);
                        total += ept.compAmount || 0;
                        return <TableRow key={ept.eventPartyTravelId}>
                            <TableCell>
                                <span title={o.label + (!!ept.plateNum ? ' ' + ept.plateNum : '')}>{o.icon || ept.vehicle}</span>
                            </TableCell>
                            <TableCell>
                                <span title={datetimeToGui(ept.beginDate, ept.beginTime)}>{dateToGuiAs(ept.beginDate, 'd. M.')}</span>
                            </TableCell>
                            <TableCell>
                                <span>{ept.beginLocation}</span>
                            </TableCell>
                            <TableCell>
                                <span title={datetimeToGui(ept.endDate, ept.endTime)}>{dateToGuiAs(ept.endDate, 'd. M.')}</span>
                            </TableCell>
                            <TableCell>
                                <span>{ept.endLocation}</span>
                            </TableCell>
                            <TableCell>
						<span>
							{!!ept.kmCnt && <>{ept.kmCnt} km</>}
						</span>
                            </TableCell>
                            <TableCell sx={{textAlign: 'right'}}>
                                <span>{formatMoney(ept.compAmount || 0, true)}</span>
                            </TableCell>
                            <TableCell>
                            </TableCell>
                        </TableRow>;
                    })}
                    <TableRow>
                        <TableCell colSpan={6}><span><strong>{t('Celkem náhrady')}</strong></span></TableCell>
                        <TableCell sx={{textAlign: 'right'}}>
					<span><strong>{formatMoney(eventParty.eventTravelDetails.reduce(
                        (s, ept) => s + (ept.compAmount || 0), 0) || 0, true)}
					</strong></span>
                        </TableCell>
                        <TableCell>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>);
    }

    if (items.length > 0) {
        items.push(<TableContainer key={'total'} component={Paper} sx={{order: 50}}>
            <Table className={'data-grid'}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{
                            width: '77%',
                            textAlign: 'left'
                        }}><span>{withAccount && !!eventParty.bankAccount
                            ? t('Celkem k výplatě na účet {{bankAccount}}', eventParty)
                            : t('Celkem k výplatě')}</span></TableCell>
                        <TableCell sx={{width: '15%', textAlign: 'right'}}>
                            <span>{formatMoney(total, true)}</span>
                        </TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                {!!event && eventParty.eventCompDetails
                    ?.some(ecd => ecd.status === JsonEventPartyCompInfoStatusEnum.Paid) && <TableBody>
                    <TableRow>
                        <TableCell colSpan={3}>
                            <span>{t('Potvrzení příjmy:')}&nbsp;{renderPaymentConfirmationFile(eventParty.eventPartyGuid!, event?.eventFrom?.substring(0, 4) || '')}</span>
                        </TableCell>
                    </TableRow>
                </TableBody>}
            </Table>
        </TableContainer>);
    }

    return items.length > 0 ? <>{items}</> : null;
}
